<div class="tab-container">
  <sysque-tab class="tab-items" 
  [content]="content"
  [titleClick]="titleClick">
</sysque-tab>
</div>